import { Pipe, PipeTransform } from '@angular/core';

export function getInitials(name?: string | null): string {
  if (!name || typeof name !== 'string') return '';
  const cleanName = name.trim();
  if (!cleanName) return '';
  const parts = cleanName.split(/\s+/).filter((p) => p.length > 0);
  if (parts.length === 0) return '';
  if (parts.length === 1) {
    return parts[0].substring(0, Math.min(2, parts[0].length)).toUpperCase();
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

@Pipe({
  name: 'initials',
  standalone: true,
})
export class InitialsPipe implements PipeTransform {
  transform(name?: string | null): string {
    return getInitials(name);
  }
}
